'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    giftcard = require('../../giftcard'),
    progress = require('../../progress'),
    dialog = require('../../dialog'),
	util = require('../../util'),
	tealium = require('../../../../../int_tealium/cartridge/js/tealium/tealium'),
	SessionAttributes = window.SessionAttributes;

/**
 * @function
 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
 */
function setCCFields(data) {
    var $creditCard = $('[data-method="CREDIT_CARD"]');
    $creditCard.find('select[name$="_type"]').val(data.type).trigger('change');
    $creditCard.find('input[name$="creditCard_owner"]').val(data.holder).trigger('change');
    $creditCard.find('input[name*="_creditCard_number"]').val(data.maskedNumber).trigger('change');
    $creditCard.find('[name$="_month"]').val(data.expirationMonth).trigger('change');
    $creditCard.find('[name$="_year"]').val(data.expirationYear).trigger('change');
    $creditCard.find('input[name*="_cvn"]:visible').val('').trigger('change');
}

/**
 * @function
 * @description Check the Coupon LineItems in the basket
 */
function checkCouponLineItems() {
	var couponCode = $('input[name$="_couponCode"]').val();
	var url = Urls.checkoutCouponLineItems+'?couponCode='+couponCode;
	$.getJSON(url, function (data) {
		if(data) {
			renderCouponCode(data.status);
		}
    });
}

// WCAG commmon function for adding dynamic aria-label value
function addAriaLabel(){
	$('.left-content .item-details .cartcoupon .value').each(function() {
		var promoValue= $(this).text().split('').join(' ');
		$(this).attr('aria-label', promoValue);
	});
}

function renderCouponCode(checkCouponFlag) {
    var code = $('input[name$="_couponCode"]').val();
    var selectedPM = $('#is-PayPal:checked').val();
    var cardUUid = "";
    var deferApplied=false;

    if(!selectedPM) {
    	selectedPM = $('#is-CREDIT_CARD:checked').val();
    	cardUUid = (typeof $('.carddetails.selected').data("uuid") !== 'undefined') ? $('.carddetails.selected').data("uuid") : "";
    }
    if($('#noPaymentNeeded').val() != "true" && $('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true" && !$('#is-PayPal').is(':checked') && $('.differedBilling input[type="checkbox"]').prop('checked') == true  ){
    	deferApplied=true;
    }
	if(checkCouponFlag) {
		var url = util.appendParamsToUrl(Urls.addCoupon, {couponCode: code, format: 'ajax'});
		let serializedBillingForm = $('#add-coupon').closest('#dwfrm_billing').serialize();
		progress.show('#main');
	    ajax.load({
			url: url,
			callback: function (data) {

                $('.redemption.coupon').html(data);
                $('.coupon-error.error.error-msg-content').html(data);
    			$('#add-coupon').closest('.tab-section').find('.right-content').find('.form-row').find('.input-focus').removeClass('input-focus');

				//WCAG adding dynamic aria-label value
				addAriaLabel();

				if(data.toString().indexOf('coupon-code-error') !== -1) {
					$('input[name$="_couponCode"]')[0].focus();
				}else{
					$('#add-coupon').closest('.tab-section').find('.right-content').find('input').val('');
					if ( SessionAttributes.IS_CUSTOMER_AUTHENTICATED || $('#isAuthenticatedCustomer').val() === 'true') {
	            		var $remainingBalance = $('.billing-cards-section').find('.paywith');
            			$remainingBalance.html('Pay $' + $('.customBasketTotal').val() + ' with');

            			if($('.spc-express-checkout').length > 0){
            				updateSummary(3);
            			}else{
            				updateSummary(2);
            			}
	            	} else {
	            		var actionURL = $(".spc-billing .billing-refresh").attr('data-refreshurl');
	            		actionURL = util.removeParamFromURL(actionURL, 'selectedPM'); // Remove if added in previous scenario.
	            		actionURL = util.appendParamToURL(actionURL, 'selectedPM', selectedPM); //Add current selected payment method
	            		actionURL = util.appendParamToURL(actionURL, 'refreshsection', 'billing');
	            		actionURL = util.appendParamToURL(actionURL, 'cardUUid', cardUUid);
	            		$(".spc-billing .billing-refresh").attr('data-refreshurl', actionURL);
                          $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                          $(document).ajaxStop(function(){
                        	  util.deSerializeCreditCardForm(serializedBillingForm,deferApplied);
                              deferApplied=false;
                              serializedBillingForm = '';
                          });
					}
					updateBasketInfo();
				}

				/** trigger ajax call to fetch the utag data for checkout page on click of Apply Coupon Button**/

				var checkoutUtagURL = Urls.getCheckoutUtagData + '?addCouponTriggered=true';
				var tealium = require('../../../../../int_tealium/cartridge/js/tealium/tealium');
				var billing = require('../../../../../app_fbb_core_sfra/cartridge/js/pages/checkout/billing');
				$.ajax({
				    url: checkoutUtagURL,
				    method: 'GET',
				    success: function(data) {
				        if (data !== '') {
				            utag_data = data.utagDL;
							billing.couponCodeLocationTealium(data);
				        }
				    }
				});
			}
		});
	} else {
		$('#add-coupon').closest('.couponcontent').find('.max-restrict').show();
	}
}

/**
 * @function
 * @description Updates the credit card form with the attributes of a given card
 * @param {String} cardID the credit card ID of a given card
 */
function populateCreditCardForm(cardID) {
    // load card details
    var url = util.appendParamToURL(Urls.billingSelectCC, 'creditCardUUID', cardID);
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                window.alert(Resources.CC_LOAD_ERROR);
                return false;
            }
            if(!$('#is-PayPal').is(':checked')) {
            	if( !util.newCardFlag ) {
            		setCCFields(data);
            	} else {
            		$('.payment-method .billingfields input').val('');
            		$('input[name$="_creditCard_saveCard"]').prop('checked', false);	//unchecks savecard checkbox
            		$('input[name$="_creditCard_saveCard"]').val("false");				//sets value of savecard checkbox as false
            		$('.payment-method .billingfields select').val('').trigger('change');
            	}
            } else {
        		$('.billingfields').addClass('hide');
            }

            if ($('#express-order-submit').length > 0) {
            	formPrepare.init({
                    formSelector: 'form[id$="express-order-submit"]',
                    continueSelector: '[name$="submit"]'
                });
            } else {
            	formPrepare.init({
                    formSelector: 'form[id$="billing"]',
                    continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]'
                });
            }
            progress.hide();
            util.newCardFlag = false;
        }
    });
}

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID,editpayment) {
    var $paymentMethods = $('.payment-method');


    $paymentMethods.removeClass('payment-method-expanded');

    var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + paymentMethodID + '"]');
    if ($selectedPaymentMethod.length === 0) {
        $selectedPaymentMethod = $('[data-method="Custom"]');
    }

    $selectedPaymentMethod.addClass('payment-method-expanded');

    // Check for Paypay selection and showing paypal message and hiding the rewardcertificate,giftcardsection  tabs.
    var $selectpayment = $('.selectpayment');
    $selectpayment.removeClass('paypal-selected');
    if ($('#is-apple-pay').is(':checked') || $('#is-PayPal').is(':checked')){
    	var selectedClass;
    	if ($('#is-apple-pay').is(':checked')) {
    		selectedClass = 'applePay-selected';
    		$('.apple-pay-container').removeClass('hide');
    		$('.checkout-button-container').addClass('hide');
    	} else {
    		selectedClass = 'paypal-selected';
    		$('.apple-pay-container').addClass('hide');
    		$('.checkout-button-container').removeClass('hide');
    	}
    	$selectpayment.addClass(selectedClass);
    	util.newCardFlag = true;
    	$selectpayment.find('.cardcancel').trigger('click');
    	$('.cvninfo.selected div.cvn:visible,.cvninfo.selected input.cvn:visible').removeClass('required');
    	$('.cvninfo.selected div.cvn:visible,.cvninfo.selected input.cvn:visible').find('.required-indicator').remove();
        $('.carddetails.selected').addClass(selectedClass).removeClass('selected');
        $('.carddetails').removeAttr('tabindex');
    	$('.differed-billing.selected').addClass(selectedClass).removeClass('selected').addClass('hide');
    	$('.cvninfo.selected').addClass(selectedClass).removeClass('selected').addClass('hide');
    	$('.spc-billing-btn span').not(".disabled-hover-event").text(Resources.CHECKOUT_PAYPAL_CONTINUE);
    	$('.spc-express-checkout .spc-summary-btn span').not(".disabled-hover-event").text(Resources.CHECKOUT_PAYPAL_CONTINUE);
    	$('.cardinfo .cvninfo.selected-info:visible').addClass('hide');
    	$("label[for='is-CREDIT_CARD']").next('.required-field').addClass('hide');
    	if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val() =="true"){
    		$('.couponsection').find('.couponcontent').removeClass('deferactive');
    		$('.differed-billing-content').addClass('hide');
    		var $deferCheckbox= $('.differedBilling input[type="checkbox"]');
            $deferCheckbox.val(false);
    		$deferCheckbox.prop('checked',false);
    		if ($('.couponsection').find('.couponcontent').is(':visible')){
    			$('.couponsection').find('.couponcontent').css('display','block');
    		}
    	}
    } else {
    	if ($('.newcreditcard.expressedit').length > 0 || $('.newselectedcard').val() === 'true') {
    		util.newCardFlag = true;
			}
		$('.apple-pay-container').addClass('hide');
		$('.checkout-button-container').removeClass('hide');
		$selectpayment.find('.button-fancy-large').not('.spc-billing-btn,.spc-summary-btn,.plcc-nothanks-button,.plcc-get-it-button').addClass('spc-billing-btn');

		if($("select[name $='_billing_paymentMethods_creditCard_type']").find('option:selected').attr("plccType") == "true") {
    		if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true"  && !$('#is-PayPal').is(':checked')){
    			$('.couponsection').find('.couponcontent').addClass('deferactive');
    			var $deferCheckbox= $('.differedBilling input[type="checkbox"]');
    			if($deferCheckbox.prop('checked') == true){
    				var $input = $('.deferCode').find('input');
    		        var $inputValue=$input.val("PAYLATER");
    		        $('#apply-defer').trigger('click');
    			}
    			if ($('.couponsection').find('.couponcontent').is(':visible')){
    				$('.couponsection').find('.couponcontent').css('display','flex');
    			}
    		}
    	}

    	if ($('.carddetails.paypal-selected').length > 0) {
    		$('.carddetails.paypal-selected').removeClass('paypal-selected');
    	} else {
    		$('.carddetails.changed').removeClass('changed');
    	}
    	//On editing billing on express checkout page, during updating payments section, 'cvninfo.paypal-selected' won't exist and hence else condition
    	if ($('.cvninfo.paypal-selected').length > 0) {
            $('.cvninfo.paypal-selected').closest('.cardinfo').find('.carddetails').addClass('selected');
    		$('.cvninfo.paypal-selected').addClass('selected').removeClass('paypal-selected').removeClass('select-default').removeClass('hide');
    	} else if ($('.cvninfo.selected').length == 0) {	// Fix for SM-4288. When a card is already selected, don't execute below condition
    		//This condition selects the default card and adds 'select-default' class to identify the default card
    		if ($('.cvninfo.selected-info').length == 1) {	// Identified this class on all cvn when edited billing
    			$('.cvninfo.selected-info').addClass('selected').addClass('select-default').removeClass('hide');
    			$('.cvninfo.selected').closest('.cardinfo').find('.carddetails').addClass('selected');
    		}else {
    			$('.cvninfo').closest('.cardinfo').find('.carddetails').each(function(){
        		    if($(this).data('uuid') == $('input[name="defaultCardUUID"]').val()) {
        		    	$(this).closest('.cardinfo').find('.cvninfo').addClass('selected').addClass('select-default').removeClass('hide');
        		    }
        		 });
    		}
    	}

    	var $cardDetails = $('.cvninfo.selected').closest('.cardinfo').find('.carddetails');
    	//(SM-4475) clearPrePopulatedForm condition is for avoiding card form pre-population for single saved card, when we edit payments from summary page.
    	if($cardDetails.hasClass('selected') && $('.skipFormPrePopulation').length == 0 && !$cardDetails.hasClass('expired')) {
    		var cardUUID = $cardDetails.data('uuid');
    		//Below added condition to avoid prepoulate CC form for the first time. Otherwise, it pre-populates the CC fields with the above selected card.
    		//This prepopulateCCForm will be set when user clicked on Select Payment Method button after billing address is updated/ Editing payment on billing section or when there is only one CC
    		if (cardUUID && !util.newCardFlag && (($('input[name *= "prepopulateCCForm"]').val() != "false"  && $('input[name *= "editedPayment"]').val() != "true") || $('.cardinfo .cvninfo').length == 1)) {
    			// Once cardUUID is there, we have to set the flag as false.
    			util.newCardFlag = false;
    			populateCreditCardForm(cardUUID);
    		}
    	}
    	$('.cvninfo.selected div.cvn:visible,.cvninfo.selected input.cvn:visible').addClass('required');
    	if($('.cvninfo.selected div.cvn:visible,.cvninfo.selected input.cvn:visible').find('.required-indicator').length <=0){
    		$('.cvninfo.selected div.cvn:visible,.cvninfo.selected input.cvn:visible').find('label').append('<span class="required-indicator"> * </span>');
    	}
    	$('.differed-billing.paypal-selected').addClass('selected').removeClass('paypal-selected').removeClass('hide');
    	if ($('.plcccard.selected').length > 0 ) {
            $('.cvninfo.selected').addClass('hide');
            $('.carddetails.plcccard').attr('tabindex','0');
    	} else {
    		$('.differed-billing.selected').addClass('hide');
    		if (editpayment != null && editpayment) {
                $('.cvninfo.selected').addClass('hide');
    		} else {
                $('.cvninfo.selected').removeClass('hide');
                if($('.carddetails.selected')){
                    $('.carddetails.selected').removeAttr('tabindex');
                }
            }
    	}
    	$selectpayment.removeClass('paypal-selected');
    	$("label[for='is-CREDIT_CARD']").next('.required-field').removeClass('hide');
    	$('.spc-billing-btn span').not(".disabled-hover-event").text(Resources.CHECKOUT_CONTINUE);
    	$('.spc-express-checkout .spc-summary-btn span').not(".disabled-hover-event").text(Resources.PLACE_ORDER);
    	//Below if-else block is added to de-select the selected card if CC form is displayed. Otherwise, selects the card and cvn if CC form is hidden.
    	if($('.payment-method .billingfields.hide').length == 0) {
			$('.cardinfo .carddetails.selected').removeClass('selected').addClass('changed');
	    	$('.cardinfo .cvninfo.selected').addClass('hide');
	    	$('.differed-billing .selected').addClass('changed hide');
    	} else {
    		$cardDetails.trigger('click');	//This triggers the selected card to populate CC form with its values when switched from paypal to CC || SM-3962
    		//This must be executed when plcc card is not selected since cvn does not exist for plcc card.
    		$('.cardinfo .carddetails.selected').addClass('selected').removeClass('changed');
    		 if ($('.plcccard.selected').length == 0) {
		    	$('.cardinfo .cvninfo.selected').removeClass('hide');
		    	$('.differed-billing .selected').removeClass('changed hide');
    		}
    	}
    	if ($('#express-order-submit').length > 0) {
         	formPrepare.init({
                 formSelector: 'form[id$="express-order-submit"]',
                 continueSelector: '[name$="submit"]'
             });
         } else {
        	 formPrepare.init({
        		 formSelector: 'form[id$="billing"]',
                 continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]'
             });
         }
    }

    // ensure checkbox of payment method is checked
    $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
    $('input[value=' + paymentMethodID + ']').prop('checked', 'checked');

    setTimeout(function () {
        formPrepare.validateForm();
    },400);
    //For guest user, Edit option is coming when billing address fields are displayed. Below code fixes it.
    if ($('.guestuser').val() == "true" && ($('.fieldsection.hide').length == 0 || $('.fieldsection').is(':visible'))) {
    	$('.editaddress').addClass('hide');
    }
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary(stepCount) {
    var $summary = $('#secondary.summary');
    // indicate progress
    progress.show($summary);
    var url = Urls.summaryRefreshURL;
    if (stepCount != null && stepCount != '') {
    	url = util.appendParamToURL(url, 'stepCount', stepCount);
    }
    // load the updated summary area
    $summary.load(url, function () {
        if($('.paywith').length > 0) {
            progress.show($summary);
            if($('.spc-express-checkout').length > 0){
            var billingUrl = Urls.expressBilling;
            } else {
                var billingUrl = Urls.billing;
            }
            $.ajax({
                url: billingUrl,
                success: function (response) {
                    var newPay = $(response).find('.paywith').html();
                    $('.paywith').html(newPay);
                    progress.hide();
                }
            });
        }
        // hide edit shipping method link
        $summary.fadeIn('fast');
        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
        if ($('#express-order-submit').length > 0) {
        	if(!$('.checkout-tabs .subscribeToEmail input[name$="_subscribeToEmail"]').is(':checked')){
        		$summary.find('.subscribeToEmail input[name$="_subscribeToEmail"]').prop('checked', false);
        		$summary.find('.subscribeToEmail input[name$="_subscribeToEmail"]').val('false');
        	}
        	formPrepare.init({
                formSelector: 'form[id$="express-order-submit"]',
                continueSelector: '[name$="submit"]'
            });
        } else {
        	formPrepare.init({
                formSelector: 'form[id$="billing"]',
                continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]'
            });
        }
    });
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateBasketInfo() {
    var $basketSummary = $('.basket-details');
    // indicate progress
    progress.show($basketSummary);

    // load the updated summary area
    $basketSummary.load(Urls.basketRefreshURL, function () {
        // hide edit shipping method link
    	$basketSummary.fadeIn('fast');
    });
}
/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function () {
    var $checkoutForm = $('.checkout-billing, .submit-express-order');
    var $addGiftCert = $('#add-giftcert');
    var $removeGiftCert = $('.remove-giftcert');
    var $giftCertCode = $('input[name$="_giftCertCode"]');
    var $addCoupon = $('#add-coupon');
    var $couponCode = $('input[name$="_couponCode"]');
    var $addRewardCert = $('#add-reward');
    var $rewardCertCode = $('input[name$="_rewardCode"]');
    var $selectPaymentMethod = $('.payment-method-options');
    var selectedPaymentMethod = $selectPaymentMethod.find(':checked').val();
    var $removeCoupon = $('#remove-coupon');
	var hasSeenRebuttalMessage = false;

    if ($('#express-order-submit').length > 0) {
    	formPrepare.init({
            formSelector: 'form[id$="express-order-submit"]',
            continueSelector: '[name$="submit"]'
        });
    } else {
    	formPrepare.init({
            formSelector: 'form[id$="billing"]',
            continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]'
        });
    }

    // default payment method to 'CREDIT_CARD'
    var editPayment = false;
    if ($('.feature-action').val() == 'payment') {
    	editPayment = true;
	}
    updatePaymentMethod((selectedPaymentMethod) ? selectedPaymentMethod : 'CREDIT_CARD',editPayment);
    $("body").off('click', '.payment-method-options input[type="radio"]').on('click', '.payment-method-options input[type="radio"]', function () {
        $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
        $('input[value=' + $(this).val() + ']').prop('checked', 'checked');
        updatePaymentMethod($(this).val());
    });

    $("body").off('keydown','.payment-method-options .custom-radio-icon').on('keydown','.payment-method-options .custom-radio-icon', function (e) {
        if(e.which == 32){
            e.preventDefault();
            $(this).closest('.payment-method-options').find('input[type="radio"]').trigger('click');
        }
	});

	//WCAG promo code dynamic aria-label on load
	addAriaLabel();

    //SM-6953, Expired card CVV fields are in opened state.
    $('.cvninfo').closest('.cardinfo').find('.carddetails').each(function(){
	    if($(this).hasClass('expired')) {
	    	$(this).closest('.cardinfo').find('.cvninfo').addClass('hide');
	    }
	 });
	 $('body').off('click','.subscribeToEmail input[type="checkbox"]').on('click','.subscribeToEmail input[type="checkbox"]', function (){
		var $checkbox= $('.subscribeToEmail input[type="checkbox"]');
		$checkbox.val(this.checked ? true : false);
		$checkbox.prop('checked', this.checked);
		if(this.checked){
			$(".add-to-email-list").find('.add-to-emaillist-warningmsg').addClass('tooltip-hidden');
		}
		else{
			$(this).closest(".add-to-email-list").find(".add-to-emaillist-warningmsg").removeClass('tooltip-hidden');
			if (typeof utag != 'undefined' && !hasSeenRebuttalMessage) {
				var obj = {};
                obj.event_name = "email_subscription_rebuttal";
                tealium.triggerViewEvent(obj);
            	hasSeenRebuttalMessage = true;
			}
		}
	});
    // select credit card from list
    $('#creditCardList').on('change', function () {
        var cardUUID = $(this).val();
        if (!cardUUID) {return;}
        populateCreditCardForm(cardUUID);

        // remove server side error
        $('.required.error').removeClass('error');
        $('.error-message').remove();
    });

    $('.card-list .showall').on('click',function(e){
    	e.preventDefault();
    	$(this).hide();
    	$('.card-list .hidedetails').show();
    });

    if ($('.selected-year').length >= 1 && $('.selected-year').val() != null && $('.selected-year').val() != undefined && $('.selected-year').val() != '') {
    	$('.billingfields .year select').val($('.selected-year').val()).trigger('change');
    }

    if ($('.newselectedcard').length >= 1 && $('.newselectedcard').val() != null && $('.newselectedcard').val() != undefined && $('.newselectedcard').val() == 'false' && selectedPaymentMethod == 'CREDIT_CARD') {
    	$('.billingfields').removeClass('hide');
    	$('.newcreditcard').addClass('hide');
    }

    // select credit card from list
    $('.cardinfo').off('click keydown','.carddetails').on('click keydown','.carddetails', function(e) {
        if( e.type === "keydown" && e.which != 13 ){
            return;
        }
    	if ($(e.target).closest('a.plcc-tooltip').length == 0) {
    		if ($('#is-PayPal').is(':checked') || $(this).hasClass('cardexpired') || $(this).hasClass('insufficient-card') || $(this).hasClass('plcc-message-card') || $(this).hasClass('paypal-selected') ) {
        		return;
        	}
    		util.newCardFlag = false;
    		util.newCreditCardTriggered=false;
            $('.carddetails').removeClass('selected');
            $('.carddetails').attr('tabindex','0');
            $(this).addClass('selected');
            if(!$(this).hasClass('plcccard')){
            $(this).removeAttr('tabindex').removeClass('focus-outline');
            }
        	$('.seleted-card').val('true');
        	var cardUUID = $(this).data('uuid');
            if (!cardUUID) {
                return;
            }

            var creditinfo;
            if ($('.cvninfo').length > 0 && $('.cvninfo.selected').children().length > 0) {
            	creditinfo = $('.cardinfo .cvninfo.selected').html();
            } else {
            	creditinfo =  $('.cardinfo .cvninfo.selected-info').html();
            }

            $('.cardinfo .cvninfo').removeClass('selected').html('');
            $('.cardinfo .cvninfo.selected-info').removeClass('selected').html('');
            $(this).next('.cvninfo').addClass('selected').html(creditinfo);

            if ($('.cardinfo .differed-billing.selected input').is(':checked')) {
            	$('.cardinfo .differed-billing.selected  input').trigger('click');
     	    }

            if ($('.cardinfo .differed-billing.selected').children().length > 0) {
            	var differinfo = $('.cardinfo .differed-billing.selected').html();
            } else if ($('.cardinfo .differed-billing.paypal-selected').length > 0) {
        		var differinfo = $('.cardinfo .differed-billing.paypal-selected').html();
            } else {
            	var differinfo = $('.card-list .differed-billing.selection').html();
            }
            $('.cardinfo .differed-billing').removeClass('selected').html('');
            $(this).parent().find('.differed-billing').addClass('selected').html(differinfo);

            if ($('.plcccard.selected').length > 0) {
      		    $('.cardinfo .cvninfo.selected').addClass('hide');
      		    if ($('.cardinfo .differed-billing.selected input').is(":checked")) {
      			   $('.cardinfo .differed-billing.selected input').trigger('click');
     		    }
                $('.differed-billing').removeClass('hide');
      	    } else {
      		    $('.cardinfo .cvninfo.selected').removeClass('hide');
      		    $('.differed-billing').addClass('hide');
      	    }
            $('.cardinfo .cvninfo span.error').remove();
            $('.cardinfo .cvninfo input').val('').removeClass('error');
            $('.cardinfo .carddetails.selected').removeClass('selected');
            $(this).addClass('selected');
            $('.billingfields').addClass('hide');

            if ($(this).hasClass('plcccard')) {
            	$('.form-row.cvn,.form-row.exp,.cvn input:visible').removeClass('required');
            } else {
            	$('.form-row.cvn,.form-row.exp,.cvn input:visible').addClass('required');
            }
            $('.newcreditcard').show();
            progress.show('#main');
            populateCreditCardForm(cardUUID);
            util.selectedCard = cardUUID;
            $('.cvn input').on('input change',function() {
                util.allowDigits($(this));
                $('.billingfields .cvn input').val($(this).val());
        	});
            $('.cvn label.error').hide();
        }
    });

    $('.cardinfo .cvninfo.selected .cvn input:visible').on('focusout',function(){
    	$('.billingfields .cvn input').val($(this).val());
    });

    $('.cvn input').on('input change',function() {
        util.allowDigits($(this));
        $('.cvn input').val($(this).val());
    });
    //Clear credit card when there is * present and value is changed
    $('.creditcardnumber input').on('keydown input',function(e) {
    	var str= $(this).val();
        if ((e.type === "keydown" && (e.which >= 48 && e.which <= 57) || (e.which >= 96 && e.which <= 105))|| e.type === "input") {
	    	if(str.charAt(0) === '*'){
	    		$(this).val('');
	    	}
        }
    });

    if($("select[name $='_billing_paymentMethods_creditCard_type']").find('option:selected').attr("plccType") == "true") {
    	var $form = $("select[name $='_billing_paymentMethods_creditCard_type']").closest(".billingfields");
    	var $formRowList = $form.find(".form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault, .saveCard, .differedBilling");
    		$formRowList.addClass("hide");
        	$formRowList.find("input,select").addClass("hide");
        	$form.find('.form-row.owner,.form-row.month,.form-row.year, .form-row.cvn').removeClass('required');
        	$form.find('.form-row.owner input,.form-row.month select,.form-row.year select,.form-row.cvn input').removeClass('required');
        	$form.find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').find('.required-indicator').remove();
        	$form.find('.form-row.creditcardnumber input').attr('minlength','8');
        	$form.find('.form-row.creditcardnumber input').attr('maxlength','16');
        	$form.find('.cvv-label').addClass("hide");
        	if($('.billingfields').length > 0 && $('.billingfields .differed-billing').length > 0) {
        		$('.billingfields .differed-billing').html($('.card-list .differed-billing.selection').html());
        		$('.billingfields .differed-billing').removeClass('hide');
        	}
            if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true"  && !$('#is-PayPal').is(':checked')){
        		$('.couponsection').find('.couponcontent').addClass('deferactive');
        		if ($('.couponsection').find('.couponcontent').is(':visible')){
        			$('.couponsection').find('.couponcontent').css('display','flex');
        		}
        	}
    } else {
    	var $form = $("select[name $='_billing_paymentMethods_creditCard_type']").closest(".billingfields");
    	$form.find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').addClass('required');
    	if($form.find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').find('.required-indicator').length <= 0){
    		$form.find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').find('label').append('<span class="required-indicator"> * </span>');
    	}
    	$form.find('.form-row.owner input,.form-row.month select,.form-row.year select,.form-row.cvn input').addClass('required');
    	$form.find('.form-row.creditcardnumber input').attr('maxlength','19');
    	$form.find('.form-row.creditcardnumber input').attr('minlength','1');
    	$form.find('.cvv-label').removeClass("hide");
    	if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val() =="true"){
    		$('.couponsection').find('.couponcontent').removeClass('deferactive');
    		$('.differed-billing-content').addClass('hide');
    		var $deferCheckbox= $('.differedBilling input[type="checkbox"]');
            $deferCheckbox.val(false);
    		$deferCheckbox.prop('checked',false);
    		if ($('.couponsection').find('.couponcontent').is(':visible')){
    			$('.couponsection').find('.couponcontent').css('display','block');
    		}
    	}
    }
    $('.savecreditcard').off('click','.cardcancel').on ('click','.cardcancel',function(e) {
    	var checkCCVInfo = $('.cvninfo.selected');
        util.newCreditCardTriggered = false;
    	if(checkCCVInfo.length == 0) {
    		$('.cvninfo').closest('.cardinfo').find('.carddetails').each(function(){
    		    if($(this).data('uuid') == $('input[name="defaultCardUUID"]').val()) {
    		    	checkCCVInfo = $(this).closest('.cardinfo').find('.cvninfo');
    		    }
    		 });
    		if (checkCCVInfo.length == 0) {
    			checkCCVInfo = $('.cvninfo.selected-info');
    		}
    	}
    	var firstCVVInfo = $('.cvninfo').first();
		//Check if already have a selected credit card
    	//otherwise select the first card if available.
    	if(checkCCVInfo.length > 0 ) {
    		checkCCVInfo.closest('.cardinfo').find('.carddetails').trigger('click');
    	}else if (firstCVVInfo.length > 0) {
    		firstCVVInfo.closest('.cardinfo').find('.carddetails').trigger('click');
    		checkCCVInfo = firstCVVInfo;
    	}

    	$('input[name$="_creditCard_saveCard"]').val("false");
    	$('.carddetails.paypal-selected').addClass('selected').removeClass('paypal-selected');
    	$('.cvninfo.paypal-selected').addClass('selected').removeClass('paypal-selected').removeClass('hide');
    	$('.differed-billing.paypal-selected').addClass('selected').removeClass('paypal-selected').removeClass('hide');
    	$("#primary .required-fields-warn,#secondary .required-fields-warn").addClass('hide');

    	if(checkCCVInfo.length > 0) {
    		checkCCVInfo.closest('.cardinfo').find('.carddetails.changed').addClass('selected').removeClass('changed');
    	} else{
    		$('.cardinfo .carddetails.changed').addClass('selected').removeClass('changed');
    	}

    	if ($('.billingfields .differed-billing input').is(':checked')) {
    		$('.billingfields .differed-billing input').trigger('click');
    	}
    	if ($('.billingfields .differed-billing').children().length > 0) {
    		var differinfo = $('.billingfields .differed-billing').html();
    	} else if ($('.cardinfo .differed-billing.paypal-selected').length > 0) {
    		var differinfo = $('.cardinfo .differed-billing.paypal-selected').html();
    	} else {
    		var differinfo = $('.cardinfo .differed-billing.selected').html();
    	}
    	$('.billingfields .differed-billing').html('');
    	$('.card-list .differed-billing.selected').html(differinfo);

    	if ($('.plcccard.selected').length > 0) {
    		$('.cardinfo .cvninfo.selected,.cardinfo .cvninfo.selected-info').addClass('hide');
    		$('.differed-billing.selected').removeClass('hide');
    	} else {
    		$('.cardinfo .cvninfo.selected,.cardinfo .cvninfo.selected-info').removeClass('hide');
    		$('.cvninfo.selected,.cardinfo .cvninfo.selected-info').show();
    		$('.differed-billing').addClass('hide');
    	}

    	$('.billingfields').addClass('hide');
    	$('.cardinfo .cvninfo .error-message').text('').hide();
    	$('.cardinfo .cvninfo input').val('').removeClass('error');
    	$('.newcreditcard').show();
    });

    $("body").off('click','#check-giftcert').on('click','#check-giftcert', function (e) {
        e.preventDefault();
        var $balance = $('.balance');
        if ($giftCertCode.length === 0 || $giftCertCode.val().length === 0) {
            var error = $balance.find('span.error');
            if (error.length === 0) {
                error = $('<span>').addClass('error').appendTo($balance);
            }
            error.html(Resources.GIFT_CERT_MISSING);
            return;
        }

        giftcard.checkBalance($giftCertCode.val(), function (data) {
            if (!data || !data.giftCertificate) {
                $balance.html(Resources.GIFT_CERT_INVALID).removeClass('success').addClass('error');
                return;
            }
            $balance.html(Resources.GIFT_CERT_BALANCE + ' ' + data.giftCertificate.balance).removeClass('error').addClass('success');
        });
    });

    $("body").off('click','#add-giftcert').on('click','#add-giftcert',function (e) {
        e.preventDefault();
        var cardNumber = $('input[name$="_svsgiftcard_cardnumber"]').val();
        var pin  = $('input[name$="_svsgiftcard_pin"]').val();
        var $error=$('.giftcert-error.error');
        if(cardNumber.trim()=='' && pin.trim()==''){
        	$('.giftcert-error.error').html(Resources.GIFTCARD_NUMBER_PIN_MISSING);
        	return false;
        }
        if(cardNumber.trim()==''){
        	$('.giftcert-error.error').html(Resources.GIFTCARD_NUMBER_MISSING);
        	return false;
        }
        if(pin.trim()==''){
        	$('.giftcert-error.error').html(Resources.GIFTCARD_PIN_MISSING);
        	return false;
        }
        var deferApplied=false;
        if($('#noPaymentNeeded').val() != "true" && $('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true" && !$('#is-PayPal').is(':checked') && $('.differedBilling input[type="checkbox"]').prop('checked') == true ){
        	deferApplied=true;
        }
        let serializedBillingForm = $(this).closest('#dwfrm_billing').serialize();
        var url = util.appendParamsToUrl(Urls.applyGiftCard, {cardNumber: cardNumber,pin : pin, giftCardPin: 'ajax'});
        progress.show('#main');
        $.getJSON(url, function (data) {
            var fail = false;
            var errorMsg = Resources.BAD_RESPONSE;
            if (!data) {
                 errorMsg = Resources.BAD_RESPONSE;
                fail = true;
            }else if(!data.giftCertificate.success){
            	 errorMsg = data.giftCertificate.responseMessage;
                 fail = true;
            }
            if (fail) {
                $error.html(errorMsg);
                progress.hide();
                return false;
            } else {
            	$('.gift-cert-used').find("input[name$='_selectedPaymentMethodID']").val('SVS_GIFT_CARD');
            	if ( SessionAttributes.IS_CUSTOMER_AUTHENTICATED || $('#isAuthenticatedCustomer').val() === 'true') {
            		if(data.giftCertificate.remainingAmount>0){
            			if($error.length){
            				$error.html('');
            			}
            			$('.paypal-radio').addClass('paypal-disable');
            			var $remainingBalance = $('.billing-cards-section').find('.paywith');
            			$remainingBalance.html(data.giftCertificate.payWithHtml);
            			var $appliedGiftCard = $('.giftcardsection').find('.left-content');
            			$appliedGiftCard.html(data.giftCertificate.appliedGiftCardHtml);
            			$('.giftcardsection').find('input').val('');
            			$('.giftcardsection').find('.form-row').find('.input-focus').removeClass('input-focus');
            			if($('.selectpayment .savedcards fieldset').find('.paypal-radio-message.paypal-combo').length <=0) {
            				$('.selectpayment .savedcards').find('fieldset').append(data.giftCertificate.paypalMessageHtml);
            			}else{
            				$('.selectpayment .savedcards fieldset').find('.paypal-radio-message').addClass('paypal-combo');
            			}
            			if($('.spc-express-checkout').length > 0){
            				updateSummary(3);
            			}else{
            				updateSummary(2);
            			}
            		}else{
            			if($('.spc-express-checkout').length > 0){
            				$(".spc-express-checkout .express-billing-refresh[data-refreshurl]").trigger('click');
            			}else{
            				$(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
            			}
            		}
            	} else {
                    $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                    $(document).ajaxStop(function(){
                    	util.deSerializeCreditCardForm(serializedBillingForm,deferApplied);
                        deferApplied=false;
                        serializedBillingForm = '';
                    });
              }
            }
        });
    });

    $("body").on('click','.remove-applied-giftcard',function(e){
      e.preventDefault();
      var serializedBillingForm = $(this).closest('#dwfrm_billing').serialize();
      var deferApplied=false;
      if($('#noPaymentNeeded').val() != "true" && $('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true" && !$('#is-PayPal').is(':checked') && $('.differedBilling input[type="checkbox"]').prop('checked') == true  ){
      	deferApplied=true;
      }
    	var url = $(this).attr('href');
    	var $error = $('.giftcert-error.error');
    	progress.show('#main');
    	ajax.getJson({
            url: url,
            callback: function (data) {
                if (!data) {
                	$error.html(Resources.BAD_RESPONSE);
                    progress.hide();
                    return false;
                }else if (!data.giftCertificate.success) {
                	$error.html(Resources.BAD_RESPONSE);
                    progress.hide();
                	return false;
                }else{
                	if ((SessionAttributes.IS_CUSTOMER_AUTHENTICATED || $('#isAuthenticatedCustomer').val() === 'true') && !$('#noPaymentNeeded').val()) {
                		var $remainingBalance = $('.billing-cards-section').find('.paywith');
            			$remainingBalance.html(data.giftCertificate.payWithHtml);
                		var $appliedGiftCard = $('.giftcardsection').find('.left-content');
                		if( $appliedGiftCard.find('.applied-code-section').length > 1 ){
							$('.remove-applied-giftcard[href="'+ url +'"]').closest('.applied-code-section').remove();
    	    			}else{
	                		$('.paypal-radio').removeClass('paypal-disable');
	                		$appliedGiftCard.html('');
	            			$('.giftcardsection').find('.toggle-content').slideToggle();
	            			$('.giftcardsection').find('.arrow-img').toggleClass('expanded');
	            			$('.selectpayment .savedcards fieldset').find('.paypal-radio-message').remove();
    	    			}

            			if($('.spc-express-checkout').length > 0){
            				updateSummary(3);
            			}else{
            				updateSummary(2);
            			}

                 	}else if((SessionAttributes.IS_CUSTOMER_AUTHENTICATED || $('#isAuthenticatedCustomer').val() === 'true') && $('#noPaymentNeeded').val()){
                 		if($('.spc-express-checkout').length > 0){
                            $(".spc-express-checkout .express-billing-refresh[data-refreshurl]").trigger('click');
                        }else{
                            $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                       }
                 	}else {
                     $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                     $(document).ajaxStop(function(){
                    	 util.deSerializeCreditCardForm(serializedBillingForm,deferApplied);
                         deferApplied=false;
                         serializedBillingForm = '';
                    });
                 	}
                    return true;
                }
            }
        });
    });

    $("body").off('click',"#add-reward").on('click',"#add-reward", function (e) {
        e.preventDefault();
		applyRewardCode(this);
    });
	function applyRewardCode(ctaReward){
		var $input = $(ctaReward).closest('.right-content').find('input');
    	if($(ctaReward).hasClass('disabled') || !$input.valid()) {
			if($(ctaReward).hasClass('add-reward')){
				$('.rewardcontent .label-text').show();
			}
    		return false;
    	}
        var code = $('input[name$="_rewardCode"]').val().toUpperCase(),
        $error = $('.rewardcontent').find('.rewardcert-error');
	    if (code.length === 0) {
	        $error.html(Resources.REWARD_CERT_MISSING).show();
	        return;
		}
		else if(!(/^(RC|RW|X)/i.test(code))) {
			$error.html(Resources.REWARD_CERT_INVALID).show();
	        return;
		}
	    var deferApplied=false;
        if($('#noPaymentNeeded').val() != "true" && $('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true" && !$('#is-PayPal').is(':checked') && $('.differedBilling input[type="checkbox"]').prop('checked') == true ){
        	deferApplied=true;
        }

        var url = util.appendParamsToUrl(Urls.redeemADSCert, {rewardCertCode: code, format: 'ajax'});
        let serializedBillingForm = $(ctaReward).closest('#dwfrm_billing').serialize();
        progress.show('#main');
        $.getJSON(url, function (data) {
	       progress.hide();
	       var fail = false;
	       var msg = '';
	       var rewardCert = data.rewardCertObj;
	       var rewardResponseCode = rewardCert!= null ? rewardCert.rewardResponseCode : '';
	       var rewardCertErrorMsg = rewardCert!= null ? rewardCert.error : '';
	       if (!data) {
	             fail = true;
	       } else if (data.status!=null && data.status!='Sucess') {
	    	   fail = true;
	    	   if(data.message!=null && data.message == 'ALREADY_ADDED')
	        	   data.message = Resources.REWARD_CERT_ALREADY_ADDED;
	           else if(rewardCert!=null && rewardResponseCode!=null && rewardResponseCode == '01')
	        	   data.message = Resources.REWARD_CERT_NOT_FOUND;
	           else if(rewardCert!=null && rewardResponseCode!=null && rewardResponseCode == '02')
	        	   data.message = Resources.REWARD_CERT_ALREADY_REDEEMED;
	           else if(rewardCert!=null && rewardResponseCode!=null && rewardResponseCode == '03')
	        	   data.message = Resources.REWARD_CERT_EXPIRED;
	           else if(rewardCert!=null && rewardResponseCode!=null && rewardResponseCode == '99')
	        	   data.message = Resources.REWARD_CERT_OTHER;
	           else if(rewardCert!=null && rewardResponseCode!=null && rewardResponseCode == 'I'){
	        	   if(rewardCertErrorMsg!=null && rewardCertErrorMsg == 'Certificate Already Redeemed')
	        		   data.message = Resources.REWARD_CERT_ALREADY_REDEEMED;
	        	   else if(rewardCertErrorMsg!=null && rewardCertErrorMsg == 'Certificate Expired')
	        		   data.message = Resources.REWARD_CERT_EXPIRED;
	        	   else if(rewardCertErrorMsg!=null && rewardCertErrorMsg == 'Certificate Number Not Found')
	        		   data.message = Resources.REWARD_CERT_NOT_FOUND;
	        	   else
	        		   data.message = Resources.REWARD_CERT_UNKNOWN;
	           }
	           else
        		   data.message = rewardCertErrorMsg;
	       }
	       if (fail) {
	    	   	if(data.status == 'Error'){
	    	   		$error.html(rewardCert.rewardCode + ' ' + data.message).show();
                    progress.hide();
	    	   	}
	    	   	return;
			} else {
				if (SessionAttributes.IS_CUSTOMER_AUTHENTICATED || $('#isAuthenticatedCustomer').val() === 'true') {
					if(data.remainingAmount>0){
						if($error.length){
							$error.html('');
						}
            			$('.paypal-radio').addClass('paypal-disable');
            			var $remainingBalance = $('.billing-cards-section').find('.paywith');
            			$remainingBalance.html(data.payWithHtml);
            			var $appliedGiftCard = $('.rewardcertificate').find('.left-content');
            			$appliedGiftCard.html(data.rewardCertHtml);
            			if($('.selectpayment .savedcards fieldset').find('.paypal-radio-message.paypal-combo').length <=0) {
            				$('.selectpayment .savedcards').find('fieldset').append(data.paypalMessageHtml);
            			}else{
            				$('.selectpayment .savedcards fieldset').find('.paypal-radio-message').addClass('paypal-combo');
            			}
            			$('.rewardcertificate').find('input').val('');
            			$('.rewardcertificate').find('.form-row').find('.input-focus').removeClass('input-focus');
            			if($('.spc-express-checkout').length > 0){
            				updateSummary(3);
            			}else{
            				updateSummary(2);
            			}
            		}else{
            			if($('.spc-express-checkout').length > 0){
                            $(".spc-express-checkout .express-billing-refresh[data-refreshurl]").trigger('click');
                        }else{
                            $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                        }
            		}
            	} else {
                    $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                    $(document).ajaxStop(function(){
                    	util.deSerializeCreditCardForm(serializedBillingForm,deferApplied);
                        deferApplied=false;
                        serializedBillingForm = '';
                    });

            	}
			}
        });
	}

    $("body").off('click',".remove-reward-certificate").on('click',".remove-reward-certificate", function(e) {
    	e.preventDefault();
    	var url = Urls.removeRewardCode;
      var uuid = $(this).data('uuid');
      var serializedBillingForm = $(this).closest('#dwfrm_billing').serialize();
      var deferApplied=false;
      if($('#noPaymentNeeded').val() != "true" && $('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true" && !$('#is-PayPal').is(':checked') && $('.differedBilling input[type="checkbox"]').prop('checked') == true ){
      	deferApplied=true;
      }
      var RCnumber = $(this).closest('.applied-code').find('.value').text().trim();
    	url = util.appendParamsToUrl(url, {uuid: uuid, rewardCertificate: RCnumber, format: 'ajax'});
    	$.getJSON(url, function (data) {
    		if ((SessionAttributes.IS_CUSTOMER_AUTHENTICATED || $('#isAuthenticatedCustomer').val() === 'true') && !$('#noPaymentNeeded').val()) {
    			if(data.previousAmount > 0){
	    			var $appliedGiftCard = $('.rewardcertificate').find('.left-content');
	    			if( $appliedGiftCard.find('.applied-code-section').length > 1 ){
	    				$('.remove-reward-certificate[data-uuid="'+ uuid +'"]').closest('.applied-code-section').remove();
	    			}else{
	    				$('.paypal-radio').removeClass('paypal-disable');
	    				$appliedGiftCard.html('');
	    				$('.selectpayment .savedcards fieldset').find('.paypal-radio-message').remove();
	        			$('.rewardcertificate').find('.toggle-content').slideToggle();
	        			$('.rewardcertificate').find('.arrow-img').toggleClass('expanded');
	    			}
	    			if($('.spc-express-checkout').length > 0){
	    				updateSummary(3);
	    			}else{
	    				updateSummary(2);
	    			}
    			}else{
                    if($('.spc-express-checkout').length > 0){
                        $(".spc-express-checkout .express-billing-refresh[data-refreshurl]").trigger('click');
                    }else{
                        $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                    }
    			}

        	}else if((SessionAttributes.IS_CUSTOMER_AUTHENTICATED || $('#isAuthenticatedCustomer').val() === 'true') && $('#noPaymentNeeded').val()){
         		if($('.spc-express-checkout').length > 0){
                    $(".spc-express-checkout .express-billing-refresh[data-refreshurl]").trigger('click');
                }else{
                    $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
               }
         	} else {
            $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
            $(document).ajaxStop(function(){
            	util.deSerializeCreditCardForm(serializedBillingForm,deferApplied);
                deferApplied=false;
                serializedBillingForm = '';
            });
        	}
    	});
    });

    $('body').off('click keypress','.reward-cert-tooltip').on('click keypress','.reward-cert-tooltip', function(e) {
      if( !e.isTrigger && e.which != 1 && e.which != 13 ){
        return;
      }
      e.preventDefault();
        dialog.open({
            url: $(this).attr('href'),
            options: {
                dialogClass: 'reward-cert-tooltip tooltip-dialog',
                width: 400
            }
        });
    });

    $('body').off('click keypress','.coupon-tooltip').on('click keypress','.coupon-tooltip', function(e) {
        if( !e.isTrigger && e.which != 1 && e.which != 13 ){
            return;
        }
        e.preventDefault();
        dialog.open({
            url: $(this).attr('href'),
            options: {
                dialogClass: 'coupon-tooltip tooltip-dialog',
                width: 400
            }
        });
    });

    $('body').off('click keypress','.gift-cert-tooltip').on('click keypress','.gift-cert-tooltip', function(e) {

        if( !e.isTrigger && e.which != 1 && e.which != 13 ){
            return;
        }
        e.preventDefault();
        dialog.open({
            url: $(this).attr('href'),
            options: {
                dialogClass: 'gift-cert-tooltip tooltip-dialog',
                width: 400
            }
        });
    });

    $('body').off('click','.cvv-tooltip').on('click','.cvv-tooltip', function(e) {
        e.preventDefault();
        dialog.open({
            url: $(this).attr('href'),
            options: {
                dialogClass: 'cvv-tooltip tooltip-dialog',
                width: 473
            }
        });
    });

    $("body").off('click','#add-coupon').on('click','#add-coupon', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $input = $(this).closest('.right-content').find('input');
        if (!$input.valid()) {
            return false;
        }
		if(/^(RC|RW|X)/i.test($input.val())) {
			if($('input[name=isSubscriptionFeeOnly]').val() === "true"){
				$("#checkout-billing-coupon-error").find(".error").addClass("hide");
				$("#checkout-billing-coupon-error").find(".error.subscriptiononly-error").removeClass("hide");
			}
			else{
				if ($('.reward-code').length !== 0) { // If we don't have reward certificate box
					$('.couponsection').find('.couponcontent').css('display','none');
					$('.couponsection').find('.arrow-img').removeClass('expanded');
					$('.rewardcertificate').find('.toggle-content').slideDown();
					$('.rewardcertificate').find('.arrow-img').addClass('expanded');
					$('.reward-code').focus().val($input.val());
					$input.val('').focusout();
					$("#checkout-billing-coupon-error").find(".error-messages").css("display","none");
					$('#add-reward').click();
				} else {
					var $error = $('.couponsection').find('.invalid-error');
					$error.removeClass('hide').css("display","block");
					$("#checkout-billing-coupon-error").find(".error-messages").css("display","block");
				}
			}
		}
		else {
			var $error = $('.couponsection').find('.code-missing'),
            code = $couponCode.val();
            $('.couponsection').find('.error').addClass('hide');
			if (code.length === 0) {
				$error.removeClass('hide');
				return;
			}
       	    checkCouponLineItems();
		}
    });

    $("body").off('click','#apply-defer').on('click','#apply-defer', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $input = $('.deferCode').find('input');
        var $inputValue=$input.val().trim().toUpperCase();
        var $checkbox= $('.differedBilling input[type="checkbox"]');

        if($inputValue == ""){
        	$('.defer-code-error').find('.empty-error').removeClass('hide');
        	return;
        }else if($('.defercoupon .value').html().includes("PAYLATER") && !$('.differed-billing-content').hasClass('hide')){
        	$('.defer-code-error').find('.max-defer-error').removeClass('hide');
        	return;
        }else{
        	var url = util.appendParamsToUrl(Urls.validateDeferCode, {deferCode: $inputValue, format: 'ajax'});
        	progress.show('#main');
            $.getJSON(url, function (data) {
    	       progress.hide();
    	       if (!data) {
    	    	   alert('service failed');
    	       }else{
    	    	   var response=data.deferValidation.success;
    	    	   if(response == true){
    	        		$('.differed-billing-content').removeClass('hide');
    	        		$input.val("");
    	        		$input.closest('.form-row').find('label').removeClass('input-focus');
    	        		$('.defercoupon').find('.value').html(data.deferValidation.value);
    	        		$checkbox.val(true);
    	        		$checkbox.prop('checked',true);
    	        		$('.defer-code-error').find('.empty-error').addClass('hide');
    	        		$('.defer-code-error').find('.max-defer-error').addClass('hide');
    	        	}else{
    	        		$('.differed-billing-content').addClass('hide');
    	        		$('.defer-code-error').find('.invalid-defer-error').removeClass('hide');
    	        		$('.defer-code-error').find('.max-defer-error').addClass('hide');
    	        		$checkbox.val(false);
    	        		$checkbox.prop('checked',false);
    	        	}
    	       }
            });
        }

    });
    $("body").off('click','#remove-defer').on('click','#remove-defer', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $checkbox= $('.differedBilling input[type="checkbox"]');
        $checkbox.val(false);
		$checkbox.prop('checked',false);
		$('.defercoupon').find('.value').html('');
        $('.differed-billing-content').addClass('hide');
    });

 // Add toggle functionality for defer Code in Billing Page
    $("body").off('click', '.differed-billing-content .see-details').on('click', '.differed-billing-content .see-details', function (e) {
        e.preventDefault();
        $('.deferred-message-cont').toggleClass('hide-mobile');
        if (!$(this).hasClass('opened')) {
            $(this).addClass('opened').text('Hide Details');
            $('.deferred-message-cont .morelink').trigger('click');
            $('.deferred-message-cont .morelink').hide();
        } else {
            $(this).removeClass('opened').text('See Details');
            $('.deferred-message-cont .morelink').show();
            $('.deferred-message-cont .morelink').trigger('click');
        }
    });



    //remove coupon on billing page
   $("body").off('click',"#remove-coupon").on('click',"#remove-coupon", function(e) {
    	e.preventDefault();
    	var selectedPM = $('#is-PayPal:checked').val();
    	var cardUUid = "";
        if(!selectedPM) {
        	selectedPM = $('#is-CREDIT_CARD:checked').val();
        	cardUUid = (typeof $('.carddetails.selected').data("uuid") !== 'undefined') ? $('.carddetails.selected').data("uuid") : "";
        }
        var url = Urls.removeCoupon;
      var uuid = $(this).data('uuid');

	  var deferApplied=false;

      if($('#noPaymentNeeded').val() != "true" && $('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true" && !$('#is-PayPal').is(':checked') && $('.differedBilling input[type="checkbox"]').prop('checked') == true  ){
      	deferApplied=true;
      }

      let serializedBillingForm = $(this).closest('#dwfrm_billing').serialize();
    	url = util.appendParamsToUrl(url, {uuid: uuid, format: 'ajax'});
    	progress.show('#main');
    	ajax.load({
    		url: url,
    		method: 'POST',
    		callback: function(data) {
    			$('.redemption.coupon').html(data);
    			$('.coupon-error.error.error-msg-content').html(data);
    			if (SessionAttributes.IS_CUSTOMER_AUTHENTICATED || $('#isAuthenticatedCustomer').val() === 'true') {
    				var $remainingBalance = $('.billing-cards-section').find('.paywith');
        			$remainingBalance.html('Pay $' + $('.customBasketTotal').val() + ' with');
        			if($('.differed-billing-content').length == 0 || $('.differed-billing-content').hasClass('hide')){
	        			$('#remove-coupon').closest('.tab-section').find('.toggle-content').slideToggle();
	        			$('#remove-coupon').closest('.tab-section').find('.arrow-img').toggleClass('expanded');
        			}
					$('#remove-coupon').closest('.tab-section').find('.right-content').find('input').val('');

					//WCAG adding dynamic aria-label value
					addAriaLabel();

        			if($('.spc-express-checkout').length > 0){
        				updateSummary(3);
        			}else{
        				updateSummary(2);
        			}
            	} else {
            		var actionURL = $(".spc-billing .billing-refresh").attr('data-refreshurl');
            		actionURL = util.removeParamFromURL(actionURL, 'selectedPM'); // Remove if added in previous scenario.
            		actionURL = util.appendParamToURL(actionURL, 'selectedPM', selectedPM); //Append the current selected payment method value.
            		actionURL = util.appendParamToURL(actionURL, 'cardUUid', cardUUid);
            		$(".spc-billing .billing-refresh").attr('data-refreshurl', actionURL);
                $(".spc-billing .billing-refresh[data-refreshurl]").trigger('click');
                $(document).ajaxStop(function(){
                	util.deSerializeCreditCardForm(serializedBillingForm,deferApplied);
                    deferApplied=false;
                    serializedBillingForm = '';
                });
            	}
    			/** trigger ajax call to fetch the utag data for checkout page on click of Apply Coupon Button**/
                var checkoutUtagURL=Urls.getCheckoutUtagData+'?removeCouponTriggered=true';
                $.ajax({
                    url: checkoutUtagURL,
                    method: 'GET',
                    success: function(data) {
                        if(data !== ''){
                            utag_data=data.utagDL;
                         }
                    }
                });
                progress.hide();
                updateBasketInfo();
    		}
    	});
    });


    $("body").off('keydown','input[name$="_couponCode"]').on('keydown','input[name$="_couponCode"]', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('#add-coupon').click();
        }
    });

   // override enter key for coupon code entry, trigger events on enter
   $("body").off('keyup','input[name$="_couponCode"]').on('keyup','input[name$="_couponCode"]', function (e) {
	   e.preventDefault();
       var rewardCertificate =  $(this).val().toUpperCase().substring(0,2);
       var validValue = new RegExp('\^[A-Za-z0-9-]+$');
       if (!validValue.test($(this).val()) && $(this).val() != '') {
           $(this).closest('.couponcontent').find('.invalid-error').show();
       } else {
       		$(this).closest('.couponcontent').find('.invalid-error').hide();
       }
	   if (rewardCertificate == 'rw') {
		   $(this).closest('.couponcontent').find('.rw-error').show();
	   } else {
		   $(this).closest('.couponcontent').find('.rw-error').hide();
	   }
   });

    $("body").off('keydown','input[name$="_giftCertCode"]').on('keydown','input[name$="_giftCertCode"]', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('#add-giftcert').click();
        }
    });

    $("#primary").off('keydown','input[name$="_deferCode"]').on('keydown','input[name$="_deferCode"]', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('#apply-defer').click();
        }

    });
    $("#primary").off('input change','input[name$="_deferCode"]').on('input change','input[name$="_deferCode"]', function (e) {
        	$('.defer-code-error').find('.invalid-defer-error').addClass('hide');
        	$('.defer-code-error').find('.empty-error').addClass('hide');
        	$('.defer-code-error').find('.max-defer-error').addClass('hide');
        	if(!$(this).closest('.deferCode').find('label').hasClass('input-focus')){
        		$(this).closest('.deferCode').find('label').addClass('input-focus');
        	}
    });


    $('input[name$="_svsgiftcard_pin"], input[name$="_svsgiftcard_cardnumber"]').keypress(function (e) {
    	if (e.which == 13) {
    		$('#add-giftcert').click();
    		return false;
    	}
    });

    $("body").off('keydown','input[name$="_rewardCode"]').on('keydown','input[name$="_rewardCode"]', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('#add-reward').click();
        }
    });
    $("body").off('input','input[name$="_rewardCode"]').on('input','input[name$="_rewardCode"]', function (e) {
	    var validValue = new RegExp('\^[A-Za-z0-9-]+$');
	    if (!validValue.test($(this).val()) && $(this).val() != "") {
	        $(this).closest('.rewardcontent').find('.rewardcert-error').html(Resources.REWARD_CERT_INVALID).show();
	    } else {
	        $(this).closest('.rewardcontent').find('.rewardcert-error').hide();
	    }
    });

    if($('input.cvn:visible').length> 0) {
    	$('input.cvn:visible').addClass('required');
    	$('input.cvn:visible').parents('.form-row').addClass('required');
    	if($('input.cvn:visible').parents('.form-row').find('.required-indicator').length <=0){
    		$('input.cvn:visible').parents('.form-row').find('label').append('<span class="required-indicator"> * </span>');
    	}
    }

    $('body').off('click','a.plcc-tooltip').on('click','a.plcc-tooltip', function(e) {
        e.preventDefault();
        dialog.open({
            url: e.target.href,
            options: {
                dialogClass: 'plcc-tooltip tooltip-dialog',
                width: 400
            }
        });
    });

    if ($('input[name="cardSelected"]').val() == 'true' && $('input[name="cardSelected"]').val() !== null && $('input[name="cardSelected"]').val() !== undefined) {
    	$('.billingfields').addClass('hide');
    	$('.newcreditcard').removeClass('hide');
    	var identifiedCard = '';
		if(util.selectedCard != '') {
			$('.cvninfo').closest('.cardinfo').find('.carddetails').each(function(){
    		    if ($(this).data('uuid') == util.selectedCard) {
    		    	identifiedCard = $(this);
    		    }
    		 });
			if (identifiedCard != '') {
				identifiedCard.trigger('click');
			}
    	}
	}

    // guest checkout::  Email vaildation on keyboard focus
    var $chkoutGuestLoginForm = $('.checkout-tabs .checkoutlogin .guest-form');
    $('body').off('keydown keypress click mousedown','.checkout-tabs .checkoutlogin .guest-form .checkout-guest-btn button').on('keydown keypress click mousedown','.checkout-tabs .checkoutlogin .guest-form .checkout-guest-btn button', function (e) {
        if((e.keyCode && e.keyCode == 13)){
        	 util.checkoutGuestSignInFocus($chkoutGuestLoginForm);
        }
    });
    $('body').off('blur','.checkout-tabs .checkoutlogin .guest-form input.input-text').on('blur','.checkout-tabs .checkoutlogin .guest-form input.input-text', function (e) {
 	   util.validateGuestEmailOnFocusOut($chkoutGuestLoginForm);
    });
    $('body').off('input','.checkout-tabs .checkoutlogin .guest-form input.input-text').on('input','.checkout-tabs .checkoutlogin .guest-form input.input-text', function() {
    	$chkoutGuestLoginForm.find('.username-checkout-guest, .emailValidCheckoutGuest').addClass('hide');
    	$chkoutGuestLoginForm.find('.form-row.emailAddress').removeClass('error-handle');
    	$(this).removeClass("error");
	});

	//sc-9902 code starts here
	$("body").on("input", ".couponsection input.coupon-code", function(){
		var selectedPaymentMethodStr = $('input[name$="_selectedPaymentMethodID"]:checked').val();
		if(selectedPaymentMethodStr === "PayPal" && (/^(RC|RW|X)/i.test($(this).val()))){
			$(".couponsection .coupon-apply button").attr("disabled", "disabled");
		}else{
			$(".couponsection .coupon-apply button").removeAttr("disabled");
		}
	});

	$("body").on("change", "input[name$='_selectedPaymentMethodID']",function(){
		$(".couponsection input.coupon-code").trigger("input");
	});
};
